<script setup lang="ts">
	import { MzBox, MzTitle } from '@monizze/monizze-components';
	import { useI18n } from 'vue-i18n';
	import { useUserStore } from '@/stores/user.ts';

	const { t } = useI18n();
	const userStore = useUserStore();
</script>

<template>
	<div class="bg-bg-default-primary rounded-t-2xl px-3 py-4 sm:p-8 flex flex-col gap-10 items-center w-full flex-1">
		<header class="w-full flex flex-col gap-2">
			<mz-title type="h1" :text="t('user.dashboard.welcome', { firstname: userStore.user.firstname })" />
			<p>{{ t('user.dashboard.subtitle') }}</p>
		</header>

		<div class="w-full max-w-[800px]">
			<mz-box>
				<div class="flex flex-col gap-10">
					<div class="flex flex-col gap-2 text-center">
						<mz-title type="h2" :text="t('partner.page.title')" no-margin />
						<p>
							{{ t('partner.page.description1') }}
							<span v-if="userStore.user.email.length" class="font-semibold">{{ userStore.user.email[0].value }}.</span>
						</p>
						<p>{{ t('partner.page.description2') }}</p>
					</div>
					<slot />
				</div>
			</mz-box>
		</div>
	</div>
</template>
